import { GA_SCHEDULE_EVENT_LABEL } from '../common/constants';
import { sendScheduleEventEventToGA } from '../common/google-analytics-functions';

$(() => {
  $('.schedule-event').click(() => {
    sendScheduleEventEventToGA(GA_SCHEDULE_EVENT_LABEL);
  });
});
